import { ISaveAppDisplayInfo, CouponParam, CouponParamPaging, ExcelStorageParams, ExcelStorageResponse } from 'interfaces/store';
import { paramsToFormData } from 'utils';
import { storeClient } from './apiClients';

export const getStore = async (sid: string) => {
  const { data } = await storeClient.get(`/v1/store/${sid}`);
  return data;
};

export const getStores = async () => {
  const { data } = await storeClient.get('/store/v1/store');
  return data;
};

export const getStoreImagesInfo = async (sid: string) => {
  const { data } = await storeClient.get(`/store/v1/${sid}/image/register/info`);
  return data;
};

export const getMe = async () => {
  const { data } = await storeClient.get('/v1/store/me');
  return data;
};

export const getMeVerTwo = async (sid: string) => {
  const { data } = await storeClient.get(`/store/v2/${sid}`);
  return data;
};

export const transformAccount = async (updateData: unknown): Promise<unknown> => {
  const { data } = await storeClient.put('/store/v1/account/transform', updateData);
  return data;
};

export const saveStoreDisplayInfo = async (params: ISaveAppDisplayInfo) => {
  const { storeId, displayData } = params;
  await storeClient.put(`/v1/store/${storeId}`, displayData);
};

export const getEmployee = async (storeId: string) => {
  const { data } = await storeClient.get(`/store/v1/${storeId}/workers`);
  return data;
};
export const addEmployee = async (storeId: string, worker) => {
  const { data } = await storeClient.post(`/store/v1/${storeId}/worker`, worker);
  return data;
};
export const updateEmployee = async (storeId: string, worker) => {
  const { data } = await storeClient.put(`/store/v1/${storeId}/worker`, worker);
  return data;
};
export const getWorkers = async () => {
  const { data } = await storeClient.get(`/store/v1/workers`);
  return data;
};
export const updateWorkers = async (updateList) => {
  const { data } = await storeClient.put(`/store/v1/workers`, updateList);
  return data;
};

export const getCoupon = async (params: CouponParam) => {
  const { data } = await storeClient.get(`/v1/store/coupon`, { params });
  return data;
};

export const getCouponGroup = async (params: CouponParamPaging) => {
  const { data } = await storeClient.get(`/v1/store/coupon/group`, { params });
  return data;
};

export const getMenuCategories = async (sid: string) => {
  const { data } = await storeClient.get(`/store/v1/${sid}/categories`);
  return data;
};

export const getMenus = async (sid: string, params?: unknown) => {
  const { data } = await storeClient.get(`/store/v1/${sid}/menu`, { params });
  return data;
};

export const getMenuDetail = async (sid: string, menuId: string) => {
  const { data } = await storeClient.get(`/store/v1/${sid}/menu/${menuId}`);
  return data;
};

export const updateMenusInfo = async (sid: string, params: unknown) => {
  const { data } = await storeClient.put(`/store/v1/${sid}/menu`, params);
  return data;
};

export const updateMenuThumbnail = async (sid: string, params: unknown) => {
  const { data } = await storeClient.put(`/store/v1/${sid}/menu/image-thumbnail`, params, {});
  return data;
};

export const updateMenuSort = async (sid: string, params: unknown) => {
  const { data } = await storeClient.put(`/store/v1/${sid}/menu/priority`, params);
  return data;
};

export const postPreSignedUrl = async (params: unknown) => {
  const { data } = await storeClient.post(`/common/files/pre-signed-url`, params);
  return data;
};

export const getTodayReport = async (params: unknown) => {
  const { data } = await storeClient.get(`/v1/store/sales`, { params });
  return data;
};

export const updateMenuStatus = async (sid, params) => {
  const { data } = await storeClient.put(`/store/v1/${sid}/status/menu`, params);
  return data;
};

export const getCompanies = async () => {
  const { data } = await storeClient.get(`/store/v2/company`);
  return data;
};

export const saveThumbnail = async (params) => {
  const { data } = await storeClient.post('/v1/store/thumbnail', params);
  return data;
};

export const saveSignatureMenuImg = async (params) => {
  const { data } = await storeClient.post('v1/store/register/info/image-order', params);
  return data;
};

export const saveSignatureMenuImgOrder = async (params) => {
  const { data } = await storeClient.post('v1/store/register/info/image-order', params);
  return data;
};

export const deleteSignatureMenuImg = async (data: unknown) => {
  await storeClient.delete('v1/store/delete/info/image', { data });
};

export const getExcelStorage = async (params: ExcelStorageParams): Promise<ExcelStorageResponse> => {
  const { data } = await storeClient.get('/v1/store/excel/storage', { params });
  return data;
};
export const downloadExcelFile = async (fileId: string, sid: string, fileName: string): Promise<Blob> => {
  const { data } = await storeClient.get<Blob>('/excel/v1/down', {
    params: { fileId, sid, fileName },
    responseType: 'blob'
  });
  return data;
};
export const exportExcel = async (params: unknown) => {
  const { data } = await storeClient.post('v1/store/excel/export', paramsToFormData(params as Record<string, unknown>));
  return data;
};
export const getCouponDetail = async (couponId, params) => {
  const { data } = await storeClient.get(`/v1/store/coupon/${couponId}`, { params });
  return data;
};

export const cancelCoupon = async (couponId: string, cancelMessage: string) => {
  const { data } = await storeClient.delete(`/v1/store/coupon/${couponId}`, {
    params: { cancelMessage }
  });
  return data;
};
export const getAdmissionHistory = async (said: string) => {
  const { data } = await storeClient.get(`/store/v1/${said}/history`);
  return data;
};

export const getLogData = async (pageNum) => {
  const { data } = await storeClient.get(`/store/v1/menu/log?page=${pageNum}`);
  return data;
};

export const getMenuStock = async (serviceDate: string) => {
  const { data } = await storeClient.get(`/menu-stock/v1?serviceDate=${serviceDate}`);
  return data;
};

export const updateMenuStock = async (params) => {
  const { data } = await storeClient.put(`/menu-stock/v1/setting`, params);
  return data;
};

export const getMenuStockDetail = async (menuId: string, params) => {
  const { data } = await storeClient.get(`/menu-stock/v1/${menuId}`, { params });
  return data;
};

export const getMenuStockTemplate = async () => {
  const { data } = await storeClient.get(`/menu-stock/v1/template`);
  return data;
};

export const updateMenuStockTemplate = async (params) => {
  const { data } = await storeClient.put(`/menu-stock/v1/template`, params);
  return data;
};
